import { useSelectedAvatar } from "@/hooks/useSelectedAvatar";
import { useProgressiveImage } from "@/hooks/useProgressiveImage";

export default function LandingPagePreview() {
  const { data } = useSelectedAvatar();

  // Use the progressive image loading hook with data from the API
  const { imgSrc, isHighResLoaded } = useProgressiveImage({
    lowResUrl: data?.preview_low_res_image_url,
    highResUrl: data?.preview_image_url
  });

  if (data && imgSrc) {
    return (
      <img
        alt={data.avatar_name}
        src={imgSrc}
        data-fullsrc={data.preview_image_url}
        className={`aspect-video w-full object-contain ${!isHighResLoaded && data.preview_low_res_image_url ? "blur-sm opacity-70 transition-all" : ""}`}
      />
    );
  }

  return null;
}
